import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { RealProblemSection } from '../components/RealProblemSection';
import { WhyOldSolutionsFail } from '../components/WhyOldSolutionsFail';
import { MechanismSection } from '../components/MechanismSection';
import { ResultsSection } from '../components/ResultsSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function SalesPage() {
  useMetaPixel();
  return <main className="bg-[#0f172a] min-h-screen text-slate-200" data-id="element-217">
      <Hero data-id="element-218" />
      <ProblemSection data-id="element-219" />
      <RealProblemSection data-id="element-220" />
      <WhyOldSolutionsFail data-id="element-221" />
      <MechanismSection data-id="element-222" />
      <ResultsSection data-id="element-223" />
      <ForWhoSection data-id="element-224" />
      <PricingSection data-id="element-225" />
      <FinalCTA data-id="element-226" />
      <Footer data-id="element-227" />
    </main>;
}